import { observer } from 'mobx-react-lite'
import type { ConversationViewModel } from '@/features/messaging/ConversationViewModel'
import { MobileConversationComposer } from '@/features/jobs/details/components/MobileJob'

export interface MobileConversationComposerContainerProps {
  conversationVm: ConversationViewModel
}

export const MobileConversationComposerContainer = observer(
  function MobileConversationComposerContainer({
    conversationVm,
  }: MobileConversationComposerContainerProps) {
    return (
      <MobileConversationComposer
        composerText={conversationVm.composerText}
        onComposerTextChange={conversationVm.setComposerText}
        onSend={conversationVm.sendMessage}
      />
    )
  },
)
